(() => {
  if (window.SpeakerVillageMotion) return;
  const root = document.documentElement;
  const controlTemplate = document.getElementById('SvMotionControlTemplate');
  if (!controlTemplate) return;
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const storageKey = 'sv.motion.paused.v1';
  const viewed = new WeakSet();
  const originalInterpolation = new WeakMap();
  let paused = false;
  try { paused = sessionStorage.getItem(storageKey) === 'true'; } catch (_) {}
  let settling;
  let observer;
  let generation = 0;
  const canMove = () => !media.matches && !paused && !document.hidden;
  const save = () => {
    try { sessionStorage.setItem(storageKey, String(paused)); } catch (_) {}
  };
  const clearEntrances = () => {
    document.querySelectorAll('.sv-motion-reveal').forEach(element => element.classList.remove('sv-motion-reveal'));
  };
  const stopEntrances = () => {
    generation += 1;
    window.clearTimeout(settling);
    root.classList.remove('sv-motion-running');
    clearEntrances();
  };
  const syncControls = () => {
    root.dataset.svMotion = 'waves';
    root.dataset.svMotionPaused = String(paused || media.matches);
    root.classList.toggle('sv-motion-flowing', !!document.querySelector('.sv-motion-wavefield') && canMove());
    document.querySelectorAll('[data-sv-motion-toggle]').forEach(button => {
      button.textContent = media.matches ? button.dataset.labelReduced : paused ? button.dataset.labelResume : button.dataset.labelPause;
      button.disabled = media.matches;
    });
  };
  const span = (className, parent, index) => {
    const element = document.createElement('span');
    element.className = className;
    if (index !== undefined) element.style.setProperty('--sv-i', index);
    parent.append(element);
    return element;
  };
  let waveSceneNumber = 0;
  const waveField = scene => {
    const field = span('sv-motion-wavefield', scene);
    const svgElement = (name, attributes, parent) => {
      const element = document.createElementNS('http://www.w3.org/2000/svg', name);
      Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
      parent.append(element);
      return element;
    };
    const svg = svgElement('svg', {
      class: 'sv-motion-waves-svg', viewBox: '0 0 1000 650',
      preserveAspectRatio: 'none', focusable: 'false', 'aria-hidden': 'true'
    }, field);
    const id = `sv-motion-wave-${++waveSceneNumber}`;
    const definitions = svgElement('defs', {}, svg);
    const gradient = svgElement('linearGradient', {
      id: `${id}-color`, gradientUnits: 'userSpaceOnUse', x1: '0', y1: '0', x2: '1000', y2: '0'
    }, definitions);
    [[0, '#c1d0b8', .9], [.25, '#a7be9a', .9], [.5, '#dce6d5', 1], [.75, '#a7be9a', .9], [1, '#c1d0b8', .9]].forEach(([offset, color, opacity]) => {
      svgElement('stop', { offset, 'stop-color': color, 'stop-opacity': opacity }, gradient);
    });
    const glow = svgElement('filter', {
      id: `${id}-glow`, x: '-20%', y: '-40%', width: '140%', height: '180%', 'color-interpolation-filters': 'sRGB'
    }, definitions);
    svgElement('feGaussianBlur', { stdDeviation: '4' }, glow);
    const paths = [[113, 0, -20], [92, 1.8, 25], [126, 3.8, 4]].map(([amplitude, phase, baseline]) => {
      const points = [];
      for (let step = 0; step <= 250; step += 1) {
        const x = step * 4;
        const angle = x / 1000 * Math.PI * 2;
        const y = 325 + baseline + Math.sin(angle * 2 + phase) * amplitude + Math.sin(angle * 3 + phase * .5) * 19 + Math.sin(angle + phase * 1.4) * 28;
        points.push(`${step === 0 ? 'M' : 'L'}${x} ${y.toFixed(3)}`);
      }
      return points.join(' ');
    });
    paths.forEach((path, index) => {
      const layer = svgElement('g', {
        class: `sv-motion-wave-layer sv-motion-wave-layer--${index + 1}`,
        fill: 'none', stroke: `url(#${id}-color)`, 'stroke-linecap': 'butt', 'stroke-linejoin': 'round'
      }, svg);
      const shape = svgElement('g', { id: `${id}-shape-${index}` }, definitions);
      svgElement('path', {
        d: path, 'stroke-width': index === 0 ? '13' : '9', opacity: index === 0 ? '.55' : '.35', filter: `url(#${id}-glow)`
      }, shape);
      for (let echo = 0; echo < 8; echo += 1) {
        const offset = (echo - 3.5) * (index === 0 ? 4.2 : 3.3);
        const stretch = 1 + (echo - 3.5) * .014;
        svgElement('path', {
          d: path, 'stroke-width': echo % 3 === 0 ? '.9' : '.65',
          opacity: (0.1 + (1 - Math.abs(echo - 3.5) / 4) * .22).toFixed(3),
          transform: `translate(${offset * .7} ${325 + offset}) scale(1 ${stretch}) translate(0 -325)`
        }, shape);
      }
      svgElement('path', { d: path, 'stroke-width': index === 0 ? '1.8' : '1.25', opacity: index === 0 ? '.98' : '.76' }, shape);
      if (index === 0) svgElement('path', { d: path, stroke: '#e2ebdc', 'stroke-width': '.6', opacity: '.8' }, shape);
      [-1000, 0, 1000].forEach(x => svgElement('use', { href: `#${id}-shape-${index}`, x }, layer));
    });
  };
  const mountControl = stage => {
    const showcase = stage.closest('.sv-spotlight');
    if (!showcase || showcase.querySelector('[data-sv-motion-controls]')) return;
    const fragment = controlTemplate.content.cloneNode(true);
    const button = fragment.querySelector('[data-sv-motion-toggle]');
    if (!button) return;
    button.addEventListener('click', () => {
      paused = !paused;
      save();
      if (paused) stopEntrances();
      syncControls();
      observe();
    });
    const toolbar = showcase.querySelector('.sv-model-toolbar');
    (toolbar || stage).after(fragment);
  };
  const decorate = scope => {
    scope.querySelectorAll('.sv-speaker-stage').forEach(stage => {
      if (!stage.querySelector('[data-motion-scene]')) {
        const scene = document.createElement('div');
        scene.className = 'sv-motion-scene';
        scene.dataset.motionScene = '';
        scene.setAttribute('aria-hidden', 'true');
        waveField(scene);
        stage.prepend(scene);
      }
      mountControl(stage);
    });
    scope.querySelectorAll('.sv-speaker-model').forEach(viewer => {
      if (!originalInterpolation.has(viewer)) originalInterpolation.set(viewer, viewer.getAttribute('interpolation-decay'));
      if (media.matches) viewer.setAttribute('interpolation-decay', '0');
      else {
        const original = originalInterpolation.get(viewer);
        if (original === null) viewer.removeAttribute('interpolation-decay');
        else viewer.setAttribute('interpolation-decay', original);
      }
    });
  };
  const playEntrance = () => {
    stopEntrances();
    if (!canMove() || !document.querySelector('.sv-listening-room')) return;
    const thisRun = generation;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (generation !== thisRun || !canMove()) return;
        root.classList.add('sv-motion-running');
        settling = window.setTimeout(() => {
          if (generation !== thisRun) return;
          root.classList.remove('sv-motion-running');
        }, 4750);
      });
    });
  };
  const observe = () => {
    observer?.disconnect();
    if (!canMove() || !('IntersectionObserver' in window)) return;
    try {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          viewed.add(entry.target);
          if (!canMove()) return;
          entry.target.classList.add('sv-motion-reveal');
          entry.target.addEventListener('animationend', () => entry.target.classList.remove('sv-motion-reveal'), { once: true });
          window.setTimeout(() => entry.target.classList.remove('sv-motion-reveal'), 1000);
        });
      }, { threshold: .1, rootMargin: '0px 0px -22px 0px' });
      document.querySelectorAll('.sv-shop-heading,.sv-category,.sv-product-card,.sv-system-invite__grid,.sv-collection-hero h1,.sv-page-hero h1').forEach((element, index) => {
        if (viewed.has(element)) return;
        element.style.setProperty('--sv-reveal-delay', `${index % 4 * 45}ms`);
        observer.observe(element);
      });
    } catch (_) {
      observer?.disconnect();
      clearEntrances();
    }
  };
  media.addEventListener('change', () => {
    stopEntrances();
    decorate(document);
    syncControls();
    observe();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopEntrances();
    syncControls();
    observe();
  });
  document.addEventListener('shopify:section:load', event => {
    decorate(event.target);
    syncControls();
    observe();
  });
  window.addEventListener('pagehide', () => {
    stopEntrances();
    root.classList.remove('sv-motion-flowing');
    observer?.disconnect();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { syncControls(); observe(); }
  });
  decorate(document);
  syncControls();
  playEntrance();
  observe();
  window.SpeakerVillageMotion = { initialized: true };
})();
